(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = root.replace(/\/$/, '') + '/';
  var programmaticOpen = false;

  function route(path) {
    return root + path.replace(/^\//, '');
  }

  function drawer() {
    return document.getElementById('sidebar-cart');
  }

  function isCartPageLink(anchor) {
    if (!anchor || !anchor.href) return false;

    try {
      var url = new URL(anchor.href, window.location.origin);
      return url.origin === window.location.origin && /\/cart\/?$/.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function open() {
    var element = drawer();
    if (!element || element.getAttribute('aria-hidden') === 'false') return;

    var trigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (trigger) {
      programmaticOpen = true;
      trigger.click();
      programmaticOpen = false;
      return;
    }

    element.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.add('is-visible');
  }

  function updateHeaderCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    document.querySelectorAll('.Header__CartCount').forEach(function (count) {
      count.textContent = String(cart.item_count);
    });

    document.querySelectorAll('.Header__CartDot').forEach(function (dot) {
      dot.classList.toggle('is-visible', cart.item_count > 0);
    });
  }

  function replaceDrawerCart(html) {
    var element = drawer();
    if (!element) return false;

    var temporary = document.createElement('div');
    temporary.innerHTML = html;

    var incoming = temporary.querySelector('#sidebar-cart .Cart') || temporary.querySelector('.Cart');
    var current = element.querySelector('.Cart');
    if (!incoming || !current) return false;

    var main = current.querySelector('.Drawer__Main');
    var scrollTop = main ? main.scrollTop : 0;
    var discountWasOpen = Boolean(current.querySelector('[data-side-cart-discount][open]'));
    current.parentNode.replaceChild(incoming, current);

    var nextMain = incoming.querySelector('.Drawer__Main');
    if (nextMain) nextMain.scrollTop = scrollTop;
    var nextDiscount = incoming.querySelector('[data-side-cart-discount]');
    if (discountWasOpen && nextDiscount) nextDiscount.open = true;

    return true;
  }

  async function refresh(shouldOpen) {
    var response = await fetch(route('cart?view=drawer&timestamp=' + Date.now()), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) throw new Error('Unable to refresh cart drawer');
    replaceDrawerCart(await response.text());

    var cartResponse = await fetch(route('cart.js'), { credentials: 'same-origin' });
    if (cartResponse.ok) updateHeaderCount(await cartResponse.json());

    if (shouldOpen) open();
  }

  async function refreshAndOpen() {
    try {
      await refresh(true);
    } catch (error) {
      var target = new URL(root, window.location.origin);
      target.searchParams.set('open-cart', '1');
      window.location.assign(target.pathname + target.search);
    }
  }

  function discountApplications(cart) {
    var applications = (cart && cart.cart_level_discount_applications) || [];
    ((cart && cart.items) || []).forEach(function (item) {
      (item.discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    return applications;
  }

  function hasAppliedCode(cart, code) {
    var normalized = code.trim().toLowerCase();
    if (!normalized) return false;

    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.some(function (discount) {
        return discount && discount.code && discount.code.toLowerCase() === normalized && discount.applicable !== false;
      });
    }

    return discountApplications(cart).some(function (application) {
      return application && application.title && application.title.toLowerCase() === normalized;
    });
  }

  function showDiscountStatus(type, message) {
    var container = document.querySelector('[data-side-cart-discount]');
    var status = container && container.querySelector('[data-side-cart-discount-status]');
    if (!status) return;

    status.classList.remove('is-error', 'is-success');
    status.classList.add(type === 'error' ? 'is-error' : 'is-success');
    status.textContent = message;
  }

  async function updateDiscount(code, source) {
    var button = source && source.closest('button');
    var container = source && source.closest('[data-side-cart-discount]');
    if (!container) return;

    var messages = container.dataset;
    if (button) button.disabled = true;
    showDiscountStatus('success', '');

    try {
      var response = await fetch(route('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ discount: code })
      });

      var cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Discount update failed');

      var applied = code === '' || hasAppliedCode(cart, code);
      await refresh(false);
      showDiscountStatus(
        applied ? 'success' : 'error',
        code === '' ? messages.messageRemoved : (applied ? messages.messageApplied : messages.messageInvalid)
      );
    } catch (error) {
      showDiscountStatus('error', messages.messageError);
      if (button) button.disabled = false;
    }
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor && isCartPageLink(anchor)) {
      if (programmaticOpen) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      if (!anchor.matches('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')) open();
      return;
    }

    var applyButton = event.target.closest && event.target.closest('[data-side-cart-discount-apply]');
    if (applyButton) {
      event.preventDefault();
      var input = applyButton.closest('[data-side-cart-discount]').querySelector('[data-side-cart-discount-input]');
      var code = input.value.trim();
      if (code) updateDiscount(code, applyButton);
      return;
    }

    var removeButton = event.target.closest && event.target.closest('[data-side-cart-discount-remove]');
    if (removeButton) {
      event.preventDefault();
      updateDiscount('', removeButton);
      return;
    }

  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches('[data-side-cart-discount] [data-side-cart-discount-input]')) return;
    event.preventDefault();
    var code = event.target.value.trim();
    if (code) updateDiscount(code, event.target);
  });

  function handleOpenCartQuery() {
    var url = new URL(window.location.href);
    if (url.searchParams.get('open-cart') !== '1') return;

    url.searchParams.delete('open-cart');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    window.requestAnimationFrame(open);
  }

  window.RockaSideCart = {
    open: open,
    refresh: refresh,
    refreshAndOpen: refreshAndOpen
  };

  handleOpenCartQuery();
})();

(function () {
  'use strict';

  function exposeRewardGoals() {
    var cart = document.getElementById('sidebar-cart');
    if (!cart) return;

    function sync() {
      // BOGOS Progress Bars are the source of truth for displayed milestones.
      // Offer eligibility and gift assignment remain entirely with BOGOS.
      cart.querySelectorAll('.SideCart__Rewards .bogos-progress-goal[aria-hidden="true"]').forEach(function (goal) {
        goal.setAttribute('aria-hidden', 'false');
      });

      cart.querySelectorAll('.SideCart__Rewards .bogos-progress-bar-container').forEach(function (bar) {
        var goals = bar.querySelectorAll('.bogos-progress-goal');
        var shippingOnly = goals.length === 1 && goals[0].dataset.goalId === '1';
        bar.classList.toggle('SideCart__Rewards--shipping-only', shippingOnly);
      });
    }

    sync();
    new MutationObserver(sync).observe(cart, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', exposeRewardGoals, { once: true });
  } else {
    exposeRewardGoals();
  }
})();
